"use strict";const e=require("styled-components").css`
    padding: 45px ${({theme:e})=>e.spacing.large};
    position: relative;

    @media (min-width: ${({theme:e})=>e.widths.medium}) {
        padding: 80px 64px;
    }

    .DXHero-container {
        display: grid;
        grid-template-areas:
            'accent'
            'content'
            'children';
        grid-row-gap: 24px;
        align-items: center;
        z-index: 2;
        position: relative;

        .DXHero-content {
            grid-area: content;
            max-width: ${({align:e})=>"left"===e?"717px":"665px"};
        }

        .DXHero-accent {
            grid-area: accent;
            width: 160px;
            margin: auto;
        }

        .DXHero-children {
            grid-area: children;
            .DXIconCard {
                .DXIconCard-content {
                    .DXIconCard-subheading {
                        margin-bottom: 14px;
                        width: 100%;
                        text-align: left;
                        justify-content: flex-start;

                        @media (min-width: 900px) {
                            margin-bottom: 6px;
                        }
                    }

                    h1 {
                        margin: 0px 0px 14px;
                        @media (min-width: 900px) {
                            margin-bottom: 20px;
                        }
                    }
                    .DXButton {
                        margin-top: 10px;
                    }
                }
            }
        }

        @media (min-width: ${({theme:e})=>e.widths.medium}) {
            grid-template-areas:
                ${({accent:e,align:t,heading:i,content:n})=>e?"left"===t?'"accent content"':'"content accent"':i||n?"content":""}
                'children children';
            grid-template-columns: ${({accent:e,align:t})=>e?"left"===t?"160px 1fr":"1fr 160px":"1fr"};
            grid-column-gap: 60px;
        }
    }

    .DXHero-backdrop {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        max-height: 460px;
        background: ${({theme:e,background:t})=>t||e.colors.primary.default};
        background-size: cover;
        background-position: center;
        z-index: 1;
        overflow: hidden;
    }
`;module.exports=e;
//# sourceMappingURL=styles.js.map
